import type { ICompany } from "components/contacts/contacts-types";
import { WORKING_ORDER } from "constants/action-types";

/**
 * Sets the working order selected company.
 * - `undefined` means the company is not fetched yet. Pass `undefined` to reset the company.
 * - `null` means the company is now inactive/deactivated/deleted.
 * - `ICompany` means the company is present.
 */
export const setWorkingCompany = (company: ICompany | null | undefined) => ({
    type: WORKING_ORDER.COMPANY.SET,
    payload: company,
});

export const resetWorkingCompany = () => setWorkingCompany(undefined);
